/**
 * Глобальный реестр провайдеров серверных команд.
 *
 * Хранит провайдеры и индексы по типам команд. Обеспечивает
 * детерминированный порядок выдачи провайдеров:
 *  1) По убыванию priority (больше — раньше).
 *  2) При равном priority сохраняется порядок регистрации.
 */
class ServerCmdProviderRegistry {
    constructor() {
        this.providers = [];
        this.byType = new Map();
        /** Счётчик порядка регистрации для стабильной сортировки при равном priority */
        this.regSeq = 0;
        this.regOrder = new Map();
    }
    /**
     * Зарегистрировать провайдер и добавить его команды в индекс.
     * Повторная регистрация по одному и тому же id игнорируется.
     * Провайдер встаёт в массивы типов по убыванию priority,
     * при равенстве — по порядку регистрации (stable).
     */
    registerProvider(p) {
        // игнорируем повторную регистрацию по id
        if (this.providers.some(x => x.id === p.id))
            return;
        this.providers.push(p);
        this.regOrder.set(p.id, this.regSeq++);
        const getPrio = (prov) => typeof prov.priority === "number" ? prov.priority : 0;
        // Убираем дубли типов из getSupported()
        const types = Array.from(new Set(p.getSupported()));
        for (const t of types) {
            const cur = this.byType.get(t);
            // работаем с копией, чтобы не мутировать ранее выданные снапшоты
            const next = cur ? cur.slice() : [];
            // избегаем дублей по id в массиве типа
            if (next.some(x => x.id === p.id)) {
                this.byType.set(t, next);
                continue;
            }
            // Вставка по приоритету (desc) со стабильностью для equal-priority.
            const pPrio = getPrio(p);
            let i = 0;
            // пропускаем всех с большим priority
            while (i < next.length && getPrio(next[i]) > pPrio)
                i++;
            // при равном priority встаём ПОСЛЕ уже стоящих (сохраняем порядок регистрации)
            while (i < next.length && getPrio(next[i]) === pPrio)
                i++;
            next.splice(i, 0, p);
            this.byType.set(t, next);
        }
    }
    /** Вернуть провайдеров для заданного типа команды (уже упорядоченных по приоритету) */
    providersFor(type) {
        const list = this.byType.get(type);
        // всегда снапшот
        return list ? list.slice() : [];
    }
}
/** Глобальный экземпляр для регистрации и поиска провайдеров */
ServerCmdProviderRegistry.serverCommands = new ServerCmdProviderRegistry();

export { ServerCmdProviderRegistry };
